import React from 'react';

import { Box, CircularProgress } from '@mui/joy';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'neutral' | 'danger' | 'success' | 'warning';
  height?: string;
  fullScreen?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  color = 'success',
  height = '200px',
  fullScreen = false,
}) => {
  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      height={fullScreen ? '100vh' : height}
      width={fullScreen ? '100vw' : '100%'}
    >
      <CircularProgress size={size} color={color} />
    </Box>
  );
};

export default LoadingSpinner;
